module.exports = __webpack_public_path__ + "img/bsg-pro-chairs2024.e012b76b.png";